// React
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { routerMiddleware } from 'connected-react-router';

// Material-UI
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

// App modules
import { configureStore } from './store';
// import createHistory from './store/history';
import App from './components';
import { apiMiddleware } from './core/api/middleware';

// TODO: Move this to history.js
// const browserHistory = createHistory();
export const store =
  window.store ||
  configureStore({
    initialState: window.__PRELOADED_STATE__,
    middleware: [
      apiMiddleware,
      // routerMiddleware(browserHistory),
    ],
  });

// TODO: Move this to theme.js
const darkLight = 'light';
export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#084586',
    },
    secondary: {
      main: '#fff',
    },
    background: {
      default: darkLight === 'dark' ? "#222222" : '#EEE'
    },
    type: darkLight,
  },
});



// TODO: Is there a better way to do this, hooks?
// export const pushHistory = (path) => browserHistory.push(path);

render(
  // Move this to app?
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('app')
);

if (process.env.NODE_ENV === 'development') {
  if (module.hot) {
    module.hot.accept();
  }

  if (!window.store) {
    window.store = store;
  }
}
